<template>
  <div
    v-if="video"
    class="content-block"
  >
    <h3 class="content-block-title">
      Video
    </h3>
    <div class="video-container">
      <iframe
        width="620"
        height="349"
        :src="'//www.youtube-nocookie.com/embed/' + video.video_id + '?rel=0'"
        frameborder="0"
        allowfullscreen
      />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    school: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      video: null,
    };
  },
};
</script>
